/// <reference path="../_references.ts"/>

module App.Questionnaire {
	angular
	.module('questionnaire', [])
	.config(['$stateProvider', ($stateProvider: ng.ui.IStateProvider) => {
		$stateProvider
			.state('zipSolutions.old.questionnaire', {
				url: 'questionnaire',
				redirectTo: 'zipSolutions.questionnaire.service',
			})
			.state('zipSolutions.old.itemQuestionnaire', {
				url: 'item-questionnaire/{itemId:int}/item-form/{formId:int}',
				redirectTo: 'zipSolutions.questionnaire.item',
			})
			.state('zipSolutions.questionnaire', {
				url: 'survey',
				redirectTo: 'zipSolutions.questionnaire.service',
			})
			.state('zipSolutions.questionnaire.service', {
				url: '/customer',
				data: {
					title: 'Pre-Service Questionnaire',
				},
				views: {
					'content@': {
						controller: 'CustomerSurveyController',
						controllerAs: 'ctrl',
						templateUrl: 'html/questionnaire/survey/customer-survey.html',
					},
				},
			})
			.state('zipSolutions.questionnaire.item', {
				url: '/maintenance/{itemId:int}/form/{formId:int}',
				data: {
					title: 'Service Item Form',
				},
				views: {
					'content@': {
						controller: 'ItemQuestionnaireController',
						controllerAs: 'ctrl',
						templateUrl: 'html/questionnaire/item/item-questionnaire.html',
					},
				},
			});
	}])
	.service('QuestionnaireService', QuestionnaireService.Factory())
	.controller('CustomerSurveyController', CustomerSurveyController)
	.controller('ItemQuestionnaireController', ItemQuestionnaireController);
}